import { gql } from '../../../__gql-types__/gql'

export const getCampaignLinkDashboardMeta = gql(`
  query GetCampaignLinkDashboardMeta {
    campaignLinkDashboardMeta {
			accountID @client
			availableDimensions {
				dateFormat
				dimensionParameterID
				dimensionName
				dimensionOptions
				helpText
				parameterType
			}
			availableClickMetrics {
				calculation
				description
				displayName
				increasePositive
				isStandard
				isUplifterClickMetric
				metricID
				setupComplete
				units
			}
			availableMetrics {
				isStandard
				increasePositive
				isUplifterClickMetric
				calculation
				description
				displayName
				metricID
				setupComplete
				units
			}
			dashboardTitle
			onloadDefaultOptions {
				enabled
				name
				value
			}
		}
  }
`)

export const getDataSourceMetricList = gql(`
	query GetDataSourceMetricList {
		dataSourceMetricList {
			dataSourceMetricList {
				description
				calculation
				increasePositive
				displayName
				metricID
				requiredMetrics
				units
			}
		}
	}
`)

export const setDashboardSettings = gql(`
	mutation SetDashboardSettings (
		$additionalMetrics: [AdditionalMetric!]
		$onloadDefaultOptions: [GenericSettingInput!]
	) {
		setLinkPerformanceDashboardAccountSettings(
			additionalMetrics: $additionalMetrics
			onloadDefaultOptions: $onloadDefaultOptions
		) {
			accountID @client
			dashboardTitle
			availableMetrics {
				isStandard
				calculation
				description
				displayName
				increasePositive
				metricID
				setupComplete
				units
			}
			onloadDefaultOptions {
				enabled
				name
				value
			}
		}
	}
`)

export const getAccountUsageData = gql(`
	query GetAccountUsageData (
		$activeUsers: Boolean!
		$totalUsers: Boolean!
		$badCodesBlocked: Boolean!
		$codesCreated: Boolean!
		$logins: Boolean!
		$invalidCodesBreakdown: Boolean!
		$startDate: String!
		$endDate: String
		$filterList: DimensionFilterList
		$granularity: String
	) {
		report {
			activeUsers (
				startDate: $startDate,
				endDate: $endDate,
				filterList: $filterList,
				granularity: $granularity
			) @include(if: $activeUsers) {
				graphData {
					dimensionName
					dimensionValues
				}
				dateRange
				dateTotalRows
				graphData {
					dimensionName
					dimensionValues
				}
				queryStartDate
				queryEndDate
				total
			}
			badCodesBlocked (
				startDate: $startDate,
				endDate: $endDate,
				filterList: $filterList,
				granularity: $granularity
			) @include(if: $badCodesBlocked) {
				graphData {
					dimensionName
					dimensionValues
				}
				dateRange
				dateTotalRows
				graphData {
					dimensionName
					dimensionValues
				}
				queryStartDate
				queryEndDate
				total
			}
			codesCreated (
				startDate: $startDate,
				endDate: $endDate,
				filterList: $filterList,
				granularity: $granularity
			) @include(if: $codesCreated) {
				graphData {
					dimensionName
					dimensionValues
				}
				dateRange
				dateTotalRows
				graphData {
					dimensionName
					dimensionValues
				}
				queryStartDate
				queryEndDate
				total
			}
			invalidCodesBreakdown (
				startDate: $startDate,
				endDate: $endDate,
				filterList: $filterList,
				granularity: $granularity
			) @include(if: $invalidCodesBreakdown) {
				graphData {
					dimensionName
					dimensionValues
				}
				dateRange
				dateTotalRows
				graphData {
					dimensionName
					dimensionValues
				}
				queryStartDate
				queryEndDate
				total
			}
			logins (
				startDate: $startDate,
				endDate: $endDate,
				filterList: $filterList,
				granularity: $granularity
			) @include(if: $logins) {
				graphData {
					dimensionName
					dimensionValues
				}
				dateRange
				dateTotalRows
				graphData {
					dimensionName
					dimensionValues
				}
				queryStartDate
				queryEndDate
				total
			}
			totalUsers (
				startDate: $startDate,
				endDate: $endDate,
				filterList: $filterList,
				granularity: $granularity
			) @include(if: $totalUsers) {
				graphData {
					dimensionName
					dimensionValues
				}
				dateRange
				dateTotalRows
				graphData {
					dimensionName
					dimensionValues
				}
				queryStartDate
				queryEndDate
				total
			}
		}
	}
`)

export const getCampaignLinkDashboardMetricClickData = gql(`
	query GetCampaignLinkDashboardMetricDataClickData (
		$endDate: String
		$campaignCodeID: String
		$filterList: DimensionFilterList
		$granularity: String!
		$matchType: String!
		$selectedMetric: String!
		$startDate: String!
	) {
		campaignLinkDashboardMetricDataClickData(
			endDate: $endDate
			campaignCodeID: $campaignCodeID
			filterList: $filterList
			granularity: $granularity
			matchType: $matchType
			selectedMetric: $selectedMetric
			startDate: $startDate
		) {
			increasePositive
			lastPeriodStartDate
			lastYearStartDate
			metricLastPeriod {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
			}
			metricLastPeriodComparison {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
				metricValue
			}
			metricPeriodOnPeriodComparison {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
				metricValue
			}
			periodComparisonVsPeriodAverage {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
				metricValue
			}
			prevPeriodStartDate
			queryEndDate
			queryStartDate
			totalMetric {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
				metricValue
			}
		}
	}
`)

export const getCampaignLinkDashboardMetricData = gql(`
	query GetCampaignLinkDashboardMetricData (
		$endDate: String
		$campaignCodeID: String
		$filterList: DimensionFilterList
		$granularity: String!
		$matchType: String!
		$selectedMetric: String!
		$startDate: String!
	) {
		campaignLinkDashboardMetricData(
			endDate: $endDate
			campaignCodeID: $campaignCodeID
			filterList: $filterList
			granularity: $granularity
			matchType: $matchType
			selectedMetric: $selectedMetric
			startDate: $startDate
		) {
			increasePositive
			lastPeriodStartDate
			lastYearStartDate
			metricLastPeriod {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
			}
			metricLastPeriodComparison {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
				metricValue
			}
			metricPeriodOnPeriodComparison {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
				metricValue
			}
			periodComparisonVsPeriodAverage {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
				metricValue
			}
			prevPeriodStartDate
			queryEndDate
			queryStartDate
			totalMetric {
				metricDisplay
				metricLastCompleteValue
				metricPrevValue
				metricTitle
				metricValue
			}
		}
	}
`)

export const getCampaignLinkDashboardGraphClickData = gql(`
	query GetCampaignLinkDashboardGraphClickData (
		$endDate: String
		$campaignCodeID: String
		$filterList: DimensionFilterList
		$granularity: String!
		$matchType: String!
		$selectedMetric: String!
		$stackDimension: String
		$startDate: String!
	) {
		campaignLinkDashboardGraphClickData (
			endDate: $endDate
			campaignCodeID: $campaignCodeID
			filterList: $filterList
			granularity: $granularity
			matchType: $matchType
			selectedMetric: $selectedMetric
			stackDimension: $stackDimension
			startDate: $startDate
		) {
			dateRange
			dateTotalRows
			graphType
			graphData {
				dimensionName,
				dimensionValues
			}
		}
	}
`)

export const getCampaignLinkDashboardGraphData = gql(`
	query GetCampaignLinkDashboardGraphData (
		$endDate: String
		$campaignCodeID: String
		$filterList: DimensionFilterList
		$granularity: String!
		$matchType: String!
		$selectedMetric: String!
		$stackDimension: String
		$startDate: String!
	) {
		campaignLinkDashboardGraph (
			endDate: $endDate
			campaignCodeID: $campaignCodeID
			filterList: $filterList
			granularity: $granularity
			matchType: $matchType
			selectedMetric: $selectedMetric
			stackDimension: $stackDimension
			startDate: $startDate
		) {
			dateRange
			dateTotalRows
			graphType
			graphData {
				dimensionName,
				dimensionValues
			}
		}
	}
`)

export const getCampaignLinkDashboardTable = gql(`
	query GetCampaignLinkDashboardTable (
		$endDate: String
		$campaignCodeID: String
		$filterList: DimensionFilterList
		$matchType: String!
		$selectedMetric: String!
		$startDate: String!
	) {
		campaignLinkDashboardTable(
			endDate: $endDate
			campaignCodeID: $campaignCodeID
			filterList: $filterList
			startDate: $startDate
			selectedMetric: $selectedMetric
			matchType: $matchType
		) {
			campaignLinks
			tableData {
				helpText
				metricID
				metricName
				metricValue
				units
			}
		}
	}
`)

export const listSavedLinkPerformanceReportsGQL = gql(`
	query ListSavedLinkPerformanceReportsGQL {
		report {
			listSavedLinkPerformanceReports {
				hiddenReportList
				savedReports {
					applyFilters {
					dimensionParameterID
					dimensionName
					dimensionOptions
				}
				availableTo
				createdBy
				createdByID
				dateCreated
				endDate
				lastEditedBy
				lastEditedByID
				lastEditedDate
				matchType
				reportName
				reportTitle
				savedReportID
				selectedMetric
				stackDimension
				startDate
				granularity
				}
				userPreferredOrder
			}
		}
	}
`)

export const saveLinkPerformanceReport = gql(`
	mutation SaveLinkPerformanceReport(
		$reportName: String!
		$reportTitle: String!
		$availableTo: String!
		$matchType: String!
		$selectedMetric: String!
		$startDate: String!
		$endDate: String
		$stackDimension: String!
		$filterList: [DimensionFilter!]
		$granularity: String
	) {
		report {
			saveLinkPerformanceReport(
				reportName: $reportName
				reportTitle: $reportTitle
				availableTo: $availableTo
				matchType: $matchType
				selectedMetric: $selectedMetric
				startDate: $startDate
				endDate: $endDate
				stackDimension: $stackDimension
				filterList: $filterList
				granularity: $granularity
			) {
				applyFilters {
					dimensionParameterID
					dimensionName
					dimensionOptions
				}
				availableTo
				createdBy
				createdByID
				dateCreated
				endDate
				lastEditedBy
				lastEditedByID
				lastEditedDate
				matchType
				reportName
				reportTitle
				savedReportID
				selectedMetric
				stackDimension
				startDate
				granularity
			}
		}
	}
`)

export const updateSavedLinkPerformanceReport = gql(`
	mutation UpdateSavedLinkPerformanceReport(
		$reportName: String
		$reportTitle: String
		$availableTo: String
		$savedReportID: String!
		$selectedMetric: String
		$stackDimension: String
		$startDate: String
		$endDate: String
		$matchType: String
		$filterList: [DimensionFilter!]
		$granularity: String
	) {
		report {
			updateSavedLinkPerformanceReport(
				reportName: $reportName
				reportTitle: $reportTitle
				availableTo: $availableTo
				savedReportID: $savedReportID
				selectedMetric: $selectedMetric
				stackDimension: $stackDimension
				startDate: $startDate
				endDate: $endDate
				matchType: $matchType
				filterList: $filterList
				granularity: $granularity
			) {
				applyFilters {
					dimensionParameterID
					dimensionName
					dimensionOptions
				}
				availableTo
				createdBy
				createdByID
				dateCreated
				endDate
				lastEditedBy
				lastEditedByID
				lastEditedDate
				matchType
				reportName
				reportTitle
				savedReportID
				selectedMetric
				stackDimension
				startDate
				granularity
			}
		}
	}
`)

export const removeSavedLinkPerformanceReport = gql(`
	mutation RemoveSavedLinkPerformanceReport(
		$savedReportID: String!
	) {
		report {
				removeSavedLinkPerformanceReport(
				savedReportID: $savedReportID
			) {
				hiddenReportList
				savedReports {
					applyFilters {
            dimensionParameterID
            dimensionName
            dimensionOptions
          }
          availableTo
          createdBy
          createdByID
          dateCreated
          endDate
          lastEditedBy
          lastEditedByID
          lastEditedDate
          matchType
          reportName
          reportTitle
          savedReportID
          selectedMetric
          stackDimension
          startDate
          granularity
				}
				userPreferredOrder
			}
		}
	}
`)

export const updateLinkPerformanceUserPrefs = gql(`
	mutation UpdateLinkPerformanceUserPrefs(
		$newOrder: [String!] 
	) {
		report {
			updateLinkPerformanceUserPrefs(
				newOrder: $newOrder
			) {
				hiddenReportList
				savedReports {
					applyFilters {
            dimensionParameterID
            dimensionName
            dimensionOptions
          }
          availableTo
          createdBy
          createdByID
          dateCreated
          endDate
          lastEditedBy
          lastEditedByID
          lastEditedDate
          matchType
          reportName
          reportTitle
          savedReportID
          selectedMetric
          stackDimension
          startDate
          granularity
				}
				userPreferredOrder
			}
		}
	}
`)

export const getLostLinksGraphData = gql(`
	query GetLostLinksGraphData (
		$startDate: String
		$endDate: String
		$selectedMetric: String
		$granularity: String
		$filterList: DimensionFilterList
		$searchFilter: SearchFilter
	) {
		report {
			linkAudit {
				linkAuditGraph(
					startDate: $startDate
					endDate: $endDate
					selectedMetric: $selectedMetric
					granularity: $granularity
					filterList: $filterList
					searchFilter: $searchFilter
				) {
					dateRange
					dateTotalRows
					graphData {
						dimensionName
						dimensionValues
					}
					queryEndDate
					queryStartDate
					total
				}
			}
		}
	}
`)

export const getLostLinksTableData = gql(`
	query GetLostLinksTableData (
		$endDate: String
		$limit: Int
		$offset: Int
		$filterList: DimensionFilterList
		$searchFilter: SearchFilter
		$selectedMetric: String
		$sortDirection: String
		$startDate: String
		$tempTable: String
	) {
		report {
			linkAudit {
				accountID @client
				linkAuditTable(
					endDate: $endDate
					limit: $limit
					offset: $offset
					filterList: $filterList
					searchFilter: $searchFilter
					selectedMetric: $selectedMetric
					sortDirection: $sortDirection
					startDate: $startDate
					tempTable: $tempTable
				) {
					firstObserved
					landingPageList
					metricFormat
					metricHeadings
					metricValues
					pageData {
						destination
						limit
						offset
						total
						totalPages
					}
					parameterHeadings
					parameterValues
				}
			}
		}
	}
`)

export const getLostLinksFilterOptions = gql(`
	query GetLostLinksFilterOptions (
		$tempTable: String
	) {
		report {
			linkAudit {
				accountID @client
				linkAuditFilters (
					tempTable: $tempTable
				) {
					parameterFilters {
						parameterID
						parameterName
						parameterOptions
					}
				}
			}
		}
	}
`)

export const listSavedLostLinksReports = gql(`
	query ListSavedLostLinksReports {
		report {
			listSavedLinkAuditReports {
				hiddenReportList
				savedReports {
					applyFilters {
						dimensionName
						dimensionOptions
						dimensionParameterID
					}
					availableTo
					createdBy
					createdByID
					dateCreated
					endDate
					granularity
					lastEditedBy
					lastEditedByID
					lastEditedDate
					matchType
					reportName
					reportTitle
					savedReportID
					selectedMetric
					stackDimension
					startDate
				}
				userPreferredOrder
			}
		}
	}
`)

export const saveNewLostLinkReport = gql(`
	mutation SaveNewLostLinkReport(
		$reportName: String!
		$reportTitle: String!
		$selectedMetric: String!
		$startDate: String!
		$availableTo: String!
		$endDate: String
		$granularity: String!
		$filterList: [DimensionFilter!]
	) {
		report {
			saveLinkAuditReport(
				reportName: $reportName
				reportTitle: $reportTitle
				selectedMetric: $selectedMetric
				startDate: $startDate
				availableTo: $availableTo
				endDate: $endDate
				granularity: $granularity
				filterList: $filterList
			) {
				applyFilters {
						dimensionName
						dimensionOptions
				}
				availableTo
				dateCreated
				createdByID
				endDate
				lastEditedByID
				lastEditedDate
				matchType
				reportTitle
				selectedMetric
				savedReportID
				startDate
			}
		}
	}
`)

export const updateSavedLostLinkReport = gql(`
	mutation UpdateSavedLostLinkReport(
		$savedReportID: String!
		$availableTo: String
		$endDate: String
		$filterList: [DimensionFilter!]
		$granularity: String
		$reportName: String
		$reportTitle: String
		$selectedMetric: String
		$startDate: String
	) {
		report {
			updateSavedLinkAuditReport(
				savedReportID: $savedReportID
				availableTo: $availableTo
				endDate: $endDate
				filterList: $filterList
				granularity: $granularity
				reportName: $reportName
				reportTitle: $reportTitle
				selectedMetric: $selectedMetric
				startDate: $startDate
			) {
				applyFilters {
					dimensionName
					dimensionOptions
					dimensionParameterID
				}
				availableTo
				createdBy
				createdByID
				dateCreated
				endDate
				granularity
				lastEditedBy
				lastEditedByID
				lastEditedDate
				matchType
				reportName
				reportTitle
				savedReportID
				selectedMetric
				stackDimension
				startDate
			}
		}
	}
`)

export const removeSavedLostLinkReport = gql(`
	mutation RemoveSavedLostLinkReport(
		$savedReportID: String!
	) {
		report {
			removeSavedLinkAuditReport(
				savedReportID: $savedReportID
			) {
				hiddenReportList
				savedReports {
					applyFilters {
						dimensionName
						dimensionOptions
						dimensionParameterID
					}
					availableTo
					createdBy
					createdByID
					dateCreated
					endDate
					granularity
					lastEditedBy
					lastEditedByID
					lastEditedDate
					matchType
					reportName
					reportTitle
					savedReportID
					selectedMetric
					stackDimension
					startDate
				}
				userPreferredOrder
			}
		}
	}
`)

export const updateSavedLostLinkReportPrefs = gql(`
	mutation UpdateSavedLostLinkReportPrefs(
		$hideReports: [String!]
		$newOrder: [String!]
	) {
		report {
			updateLinkAuditUserPrefs(
				hideReports: $hideReports
				newOrder: $newOrder
			) {
				hiddenReportList
				savedReports {
					applyFilters {
						dimensionName
						dimensionOptions
						dimensionParameterID
					}
					availableTo
					createdBy
					createdByID
					dateCreated
					endDate
					granularity
					lastEditedBy
					lastEditedByID
					lastEditedDate
					matchType
					reportName
					reportTitle
					savedReportID
					selectedMetric
					stackDimension
					startDate
				}
				userPreferredOrder
			}
		}
	}
`)

export const listRemoteDashboards = gql(`
	query ListRemoteDashboards {
		report {
			listRemoteDashboards {
				remoteDashboards {
					dashboardDescription
					dashboardID
					dashboardName
					dashboardSource
					dashboardThumbnail
					dateAdded
					embedLink
					lastAccessed
					userAdded
				}
			}
		}
	}
`)

export const addRemoteDashboard = gql(`
	mutation AddRemoteDashboard (
		$dashboardName: String!
		$embedLink: String!
	) {
		report {
			addCustomEmbeddedDashboard(
				dashboardName: $dashboardName, 
				embedLink: $embedLink
			) {
				dashboardDescription
				dashboardID
				dashboardName
				dashboardSource
				dashboardThumbnail
				dateAdded
				embedLink
				lastAccessed
				userAdded
			}
		}
	}
`)

export const deleteRemoteDashboard = gql(`
	mutation DeleteRemoteDashboard (
		$dashboardID: String!
	) {
		report {
			deleteCustomEmbeddedDashboard(
				dashboardID: $dashboardID
			) {
				dashboardDescription
				dashboardID
				dashboardName
				dashboardSource
				dashboardThumbnail
				dateAdded
				embedLink
				lastAccessed
				userAdded
			}
		}
	}
`)

export const updateRemoteDashboard = gql(`
	mutation UpdateRemoteDashboard (
		$dashboardID: String!
		$dashboardName: String
		$dashboardDescription: String
		$embedLink: String
	) {
		report {
			updateCustomEmbeddedDashboard(
				dashboardID: $dashboardID
				dashboardName: $dashboardName
				dashboardDescription: $dashboardDescription
				embedLink: $embedLink
			) {
				dashboardDescription
				dashboardID
				dashboardName
				dashboardSource
				dashboardThumbnail
				dateAdded
				embedLink
				lastAccessed
				userAdded
			}
		}
	}
`)
